/* eslint-disable no-undef */
import Vue from "vue";
import Router from "vue-router";
import { store } from "./store/store";

Vue.use(Router);

const router = new Router({
    base: process.env.VUE_APP_BASE_ROUTE,
    mode: "history",
    routes: [
        {
            path: "/",
            component: () => import("./view/Home/home.vue"),
            meta: true
        },
        {
            path: "/login",
            name: "login",
            component: () => import("./view/User/Login/Index.vue")
        },
        {
            path: "/home",
            name: "home",
            meta: {
                requiresAuth: true
            },
            props: true,
            component: () => import("./view/Home/home.vue")
        },
        {
            path: "/investor/",
            name: "Inverstor",
            component: () => import("./view/Investor/Index.vue"),
            meta: true
        },
        {
            path: "/portfolio/",
            name: "portfolio",
            component: () => import("./view/Portfolio/Index.vue"),
            meta: true
        },
        {
            path: "/plants/SOL/:id",
            component: () => import("./view/Plant/Solar/Index.vue"),
            props(route) {
                const id = route.params.id || "";
                return { id };
            },
            meta: true
        },
        {
            path: "/plants/UTE/:id",
            component: () => import("./view/Plant/UTE/Index.vue"),
            props(route) {
                const id = route.params.id || "";
                return { id };
            },
            meta: true
        },
        {
            path: "/equipments/UTE/:id",
            component: () => import("./view/Plant/UTE/Index.vue"),
            props(route) {
                const id = route.params.id || "";
                return { id };
            },
            meta: true
        },
        {
            path: "/plants/PCH/:id",
            component: () => import("./view/Plant/PCH/Index.vue"),
            props(route) {
                const id = route.params.id || "";
                return { id };
            },
            meta: true
        },
        {
            path: "/plants/EOL/:id",
            component: () => import("./view/Plant/EOL/Index.vue"),
            props(route) {
                const id = route.params.id || "";
                return { id };
            },
            meta: true
        },
        {
            path: "/kpis/",
            name: "KPIs",
            component: () => import("./view/KPI/Index.vue")
        },
        {
            path: "/events/:id?",
            name: "Eventos",
            component: () => import("./view/Alarms/Alarms.vue")
        },
        {
            path: "/goals",
            name: "goals",
            component: () => import("./view/Goals/Goals.vue"),
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/users",
            name: "users",
            component: () => import("./view/User/Table/Index.vue"),
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/groups",
            name: "groups",
            component: () => import("./view/User/AccessGroup/Index.vue"),
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/bop_diagrams",
            name: "bop_diagrams",
            component: () => import("./view/BOP/Diagrams.vue"),
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/broker_debug",
            name: "broker_debug",
            component: () => import("./view/Debuggers/broker/brokerDebugEdit.vue"),
            meta: {
                requiresAuth: true
            }
        },
        {
            // TODO: Remove component and route
            path: "/nav_debug",
            name: "nav_debug",
            component: () => import("./view/Debuggers/navDebug.vue"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/consolidated_data",
            name: "consolidated_data",
            component: () => import("./view/ConsolidatedData/Index.vue"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/queryzer",
            name: "queryzer",
            component: () => import("./view/Debuggers/Queryzer/Queryzer.vue"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/config_app",
            name: "config_app",
            component: () => import("./view/Configuration/Configuration.vue"),
            meta: {
                requiresAuth: true
            }
        }
    ]
});

// eslint-disable-next-line no-unused-vars
function redirectTo(routeName, message = "") {
    if (message != "") {
        router.push({
            name: routeName,
            params: {
                message: message
            },
            query: {
                redirect: routeName
            }
        });
    } else {
        router.push({
            name: routeName,
            query: {
                redirect: routeName
            }
        });
    }
}

router.beforeEach((to, from, next) => {
    if (to.matched.some(item => item.meta.requiresAuth)) {
        if (!store.getters.hasTokens) {
            next({ path: "/login" });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
